import { composeStateMachine } from '@opengov/app-core/module';
import { IReportDatasetLens, IReportDatasetLensResponse } from '@opengov/reporting-types';
import { produce } from 'immer';

export type ingestionStatus = 'COMPLETE' | 'INPROGRESS' | 'INVALID' | '' | 'UNAVAILABLE';
export interface IReportDatasetLensesStatus {
  dataUpdatedAt: string;
  id: string;
  name: string;
  ingestionStatus: ingestionStatus;
}

export interface ILensState {
  lenses: IReportDatasetLensResponse[];
  lensesLoading: boolean;
  lensesWithColumns: IReportDatasetLens[];
  lensesWithColumnsLoadingQueue: string[];
  reportDatasetLensesStatus: IReportDatasetLensesStatus[];
}

export const lensInitialState: ILensState = Object.freeze({
  lenses: [],
  lensesLoading: false,
  lensesWithColumns: [],
  lensesWithColumnsLoadingQueue: [],
  reportDatasetLensesStatus: []
});

export const lensState = composeStateMachine('lenses', lensInitialState, (compose) => ({
  setLenses: compose.action((state, payload: IReportDatasetLensResponse[]) => {
    return produce(state, (draft) => {
      draft.lenses = payload;
      draft.lensesLoading = false;
    });
  }),
  addLensWithColumns: compose.action((state, payload: IReportDatasetLens) => {
    return produce(state, (draft) => {
      draft.lensesWithColumns.push(payload);
    });
  }),
  pushLensWithColumnQueue: compose.action((state, lensId: string) =>
    produce(state, (draft) => {
      draft.lensesWithColumnsLoadingQueue.push(lensId);
    })
  ),
  popLensWithColumnQueue: compose.action((state, lensId: string) =>
    produce(state, (draft) => {
      draft.lensesWithColumnsLoadingQueue = draft.lensesWithColumnsLoadingQueue.filter((id) => id !== lensId);
    })
  ),
  setLensesLoading: compose.action((state, loading: boolean) => {
    return produce(state, (draft) => {
      draft.lensesLoading = loading;
    });
  }),
  setReportDatasetLensesStatus: compose.action((state, payload: IReportDatasetLensesStatus[]) => {
    return produce(state, (draft) => {
      draft.reportDatasetLensesStatus = payload;
    });
  })
}));

export const {
  actions: lensActions,
  actionCreators: lensActionCreators,
  reducer: lensReducer,
  selector: lensSelector
} = lensState;
